const baseApiPath = {
  loginApi: process.env.REACT_APP_BASE_API_URL,
  mainApi: process.env.REACT_APP_LOGIN_API_URL,
};
export default baseApiPath;
